<script>
    import { push } from 'svelte-spa-router'
    import Hamburger from '../menu.svelte'

    import { openfront } from "../stores2.js"
    import { openbehind } from "../stores3.js"
    import Modalfront from "./modal-front.svelte"
    import Modalbehind from "./modal-behind.svelte"
    import { group_data } from "./data"


    import { fly } from 'svelte/transition'


    // npm から取ってくる
    import { onMount, onDestroy } from 'svelte';
    // この component（ Numbers.svelte ）が消えても　最後の y値 が消えないように stores 保存 
    import { y_last } from "../stores1.js"


    // この component（ Numbers.svelte ）が消えるときに発動
    onDestroy(() => {
        // 最後の y値 を保存
        y_last.set(y_value)
    })

    // この component が現れるときに発動
    onMount(() => {
        // y値 を 最後の y値（= $y_last）と同じにする
        y_value = $y_last
    })

    let y_value;

    var menu_counter = 0
        let menu_status = "off"

    const hamburger = () => {
        menu_counter++
        if (menu_counter % 1) {
            menu_status = "on"
        } else {
            menu_status = "off"
        }
    }

    let info = group_data
    let selectedInfo = {}

    const getLength = () => {
	    let i = 0
	    while (info.groups[i]) {
		    let ref = info.group_info[info.groups[i]]
            let choose = info.groups[i]
		    ref.showLength = ref.show_name.length
            ref.nameLength = choose.length
            ref.locationLength = ref.location.length
            ref.msgLength = ref.msg.length
		    ref.group_name = info.groups[i]
            ref.show_name_short = ref.show_name.replace(/\s+/g, "")
		    console.log(ref)
		    i++
	    }
    }


    const openModal = (group_name) => {
        selectedInfo = info.group_info[group_name]
        console.log(selectedInfo)
        openfront.set(true)
        openbehind.set(false)
    }
    
    getLength()

    import { nightmode } from "../stores5.js"

    const top = e => {
        y_value = 0
    }

    import * as animateScroll from "svelte-scrollto";

    import { selectCategory } from "./sarch"
    ($selectCategory) = "all"
    

    import Sarch from '../base3/sarch.svelte'

    var sarch_counter = 0
    const openSarch = () => {
        sarch_counter++
    }

    import Policy from '../policy.svelte'
    import { policy } from '../stores6'

    const openPolicy = () => {
        policy.set(true)
    }
</script>

<div class:night={$nightmode} style="padding-left:8px;">
    <header class="header" transition:fly="{{x: 200}}">
        <div class="header-space1"></div>
        <div class="header-title" class:header-title-night={$nightmode} on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="header-space2"></div>
    </header>
    <div class="catch">
        <div class="catch-item1" transition:fly="{{x: 200}}"></div>
        <div class="catch-item2" class:catch-item2-night={$nightmode} transition:fly="{{x: -200}}">団体紹介/予約</div>
    </div>
    <p style="font-size:20px; font-weight:700; color:red; margin:20px 0; margin-left:2%; width:85%;" transition:fly="{{x: 200}}">飛沫感染防止の観点から、当日発表は不可となりました。<br>団体情報に変更がありましたら、随時更新します。<br>予約は生徒のみが利用可能です。<br>予約は団体のカードの裏面のリンクより可能です。</p>
</div>
<div style="padding:20px 0 40px; padding-left:calc( 8px + 2% )" class:night={$nightmode}>
    <div class="sarch-btn" class:sarch-btn-night={$nightmode} on:click={openSarch}>簡易検索</div>
    {#if sarch_counter % 2 === 1}
    <Sarch/>
    {/if}
</div>
{#if ($selectCategory) === "all"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "movie"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name}
        {#if info.group_info[group_name].category.find(function(element){return element == "映像"})}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "exhibition"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name, i}
        {#if info.group_info[group_name].category.find(function(element){return element == "展示"})}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "performance"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name, i}
        {#if info.group_info[group_name].category.find(function(element){return element == "パフォーマンス"})}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "attraction"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name, i}
        {#if info.group_info[group_name].category.find(function(element){return element == "アトラクション"})}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "drama"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name, i}
        {#if info.group_info[group_name].category.find(function(element){return element == "劇"})}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "class"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name, i}
        {#if info.group_info[group_name].type === "class"}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "club"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name, i}
        {#if info.group_info[group_name].type === "club"}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "volunteer"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name, i}
        {#if info.group_info[group_name].type === "volunteer"}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "committee"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name, i}
        {#if info.group_info[group_name].type === "committee"}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "booking"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name, i}
        {#if info.group_info[group_name].booking === "あり"}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{:else if ($selectCategory) === "noBooking"}
<div class:night={$nightmode}>
    <div class="group-block" transition:fly="{{x: -200}}">
        {#each group_data.groups as group_name, i}
        {#if info.group_info[group_name].booking === "無し"}
        <div class="group" on:click={() => {openModal(group_name)}}>
            <div class="group-img" style="background-image: url({info.group_info[group_name].img})"></div>
            <div class="group-box" class:group-box-night={$nightmode}>
                <p class="group-name" style="font-size:{390/(group_name.length+8)}px;" class:group-name-night={$nightmode}>{group_name.replace(/\s+/g, "")}</p>
                <div></div>
            </div>
            <div class="group-category">{info.group_info[group_name].category}/{info.group_info[group_name].location}</div>
        </div>
        {/if}
        {/each}
    </div>
</div>
{/if}
<div class:night={$nightmode}>
    <footer class="footer">
        <div class="footer-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="policy" on:click={openPolicy}>プライバシーポリシー</div>
        <div class="footer-copyright">Copyright © 第75回記念祭 All Rights Reserved</div>
    </footer>
</div>

<div class="top" on:click={() => animateScroll.scrollToTop()}>↑</div>

{#if $openfront}
<Modalfront {...selectedInfo}/>
{/if}

{#if $openbehind}
<Modalbehind {...selectedInfo}/>
{/if}


{#if menu_counter % 2 === 1}
<Hamburger/>
{/if}

{#if $policy}
<Policy/>
{/if}

<svelte:window bind:scrollY={y_value}/>


<style>
.night{
    background-color: #222831;
    color:#DDDDDD;
}
.header{
    display:flex;
    flex-wrap: wrap;
    width:100%;
}
.header-space1{
    flex-basis:44%;
}
.header-title{
    font-size:24px;
    font-weight: 400;
    text-align: right;
    letter-spacing: 5px;
    margin-top:16px;
    margin-bottom:16px;
    flex-basis:50%;
    font-family: 'Noto Sans JP';
    cursor: pointer;
}
.header-title-night{
    color:#dddddd;
}
.header-space2{
    flex-basis:6%;
}
.catch{
    position:relative;
    width:100%;
    height:580px;
    overflow: hidden;
}
.catch-item1{
    position:absolute;
    top:20px;
    right:-15px;
    width:80%;
    height:500px;
    background-image: url(/img/kinensai-pic-4.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 16% 50%;
    border-radius: 20px;
}
.catch-item2{
    display:table;
    background-color: greenyellow;
    position:absolute;
    top:500px;
    left:2%;
    font-size:40px;
    letter-spacing:.05em;
}
.catch-item2-night{
    color:#000000;
}
.sarch-btn{
    width:150px;
    font-size:20px;
    font-weight:700;
    letter-spacing: 0.1em;
    margin:20px;
    margin-left:0;
    text-align: center;
    border-left:6px solid greenyellow;
    cursor: pointer;
}
.icon-sarch{
    margin:6px;
    text-align:center;
}
.sarch-btn-night{
    color:#dddddd;
}
.group-block{
    display:flex;
    flex-wrap:wrap;
    flex-direction: row;
}
.group{
    position:relative;
    margin:0 3% 20px 2%;
    width:320px;
    height:340px;
    cursor: pointer;
}
.group-img{
    background-size:cover;
    background-repeat:no-repeat;
    background-position:50% 50%;
    width:300px;
    height:200px;
    border:1px solid;
}
.group-box{
    position: absolute;
    top:10px;
    left:10px;
    border: solid 10px greenyellow;
}
.group-box p{
    position: absolute;
    display: inline-block;
    bottom: -25px;
    right: 10px;
    padding: 0 9px;
    font-weight:700;
    line-height:25px;
    text-align:right;
    color:#000000;
    background-color: #FFFfff;
}
.group-name-night{
    background-color:#222831 !important;
    color:#dddddd !important;
}
.group-box div{
    width:300px;
    height:200px;
}
@media screen and (max-width:375px){
    .group{
        width:290px;
    }
    .group-img{
        width:290px;
    }
}
@media screen and (min-width:411px){
    .group{
        width:350px;
    }
    .group-img{
        width:330px;
    }
    .group-box div{
        width:340px;
    }
}
@media screen and (min-width:768px){
    .group{
        width:340px;
    }
    .group-img{
        width:310px;
    }
    .group-box div{
        width:310px;
    }
}
@media screen and (min-width:1024px){
    .group{
        width:290px;
    }
    .group-img{
        width:280px;
    }
    .group-box div{
        width:280px;
    }
}
.group-category{
    margin:55px 0 0 10px;
    font-size:14px;
    font-weight:400;
}
.footer{
    margin-left: calc(8px + 2% );
    padding:40px 0 40px 0;
    width:85%;
    border-top:1px solid black;
}
.footer-title{
    text-align: left;
    font-size:26px;
    font-weight:300;
    cursor: pointer;
}
.footer-copyright{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
}
.policy{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
    cursor: pointer;
}
.top{
    position:fixed;
    bottom:40px;
    right:20px;
    padding:20px;
    border-radius: 35px;
    z-index:0;
    background-color:#dddddd;
    font-weight: 900;
    font-size:30px;
    box-shadow: 0 0px 20px rgba(0,0,0,0.4);
    cursor: pointer;
}
</style>